import { useState, useEffect, useMemo } from "react";
import { GridLayout } from "./layout";

const OpenAssessmentComp = ({ data, answerContent }) => {
   
    return (
        <textarea onChange={(event) => answerContent(event.target.value)} className="open-assessment" value={data.quiz_answer} placeholder={"Beantwoord de open vraag"}>

        </textarea>
    );
};

export default OpenAssessmentComp;